import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@app/material.module';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar-portable';

import { SharedModule } from '@app/shared/shared.module';
import { ShellComponent } from './shell.component';
import { ShellRoutingModule } from './shell-routing.module';
import { HeaderComponent } from './header/header.component';
import { SHARED_IMPORTS } from '@app/shared/shared.imports';
import { Select } from 'primeng/select';

@NgModule({
  imports: [...SHARED_IMPORTS, ShellRoutingModule, FlexLayoutModule, PerfectScrollbarModule, Select],
  declarations: [ShellComponent, HeaderComponent],
  exports: [MaterialModule, ShellComponent]
})
export class ShellModule {}
